import { Injectable } from '@angular/core';

@Injectable()
export class MessagesService {
public msgs = [];
  constructor() { }

}
